import React from 'react'
import { useSelector } from 'react-redux';


export default function PersonaAdditionalInfo() {
    const searchFormData = useSelector((state) => state.searchFormData.value);

    return (
        <div className='flex font-firstFont text-sm tracking-wider mt-5 mb-7'>
            <div>Age/ <span className='text-transparentWhite45'>{
                searchFormData.age &&
                searchFormData.age.map((item, i) => (
                    item + `${i !== searchFormData.age.length - 1 ? ', ' : ''}`
                ))
            }</span></div>
            <div className='ml-[3.125rem]'>Region/ <span className='text-transparentWhite45 capitalize'>{
                searchFormData.region &&
                searchFormData.region.map((item, i) => (
                    item + `${i !== searchFormData.region.length - 1 ? ', ' : ''}`
                ))
            }</span></div>
            <div className='ml-[3.125rem]'>Kids/ <span className='text-transparentWhite45'>
                {
                    searchFormData.kids ?
                        "With kids" : "Without kids"
                }</span></div>
        </div>
    )
}
